import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import useStateHandler from "@/hooks/useStateHandler";
import useTranslations from "@/i18n/useTranslations";
import HomeCarouselAnalyticsService from "@/services/homeCarouselAnalytics.service";
// Ajusta este import al path real de tu UserCard:
import UserSliderCard from "@/shared-components/cards/components/UserSliderCard"; 
import FHSlider from "@/shared-components/sliders/components/FHSlider";
import Heading from "@/shared-components/text/components/Heading";
import Text from "@/shared-components/text/components/Text";

import useCarouselImpressionTracking from "./hooks/useCarouselImpressionTracking";
import DiscoverHeaderControls from "./DiscoverHeaderControls";

import "./styles/HomeUsers.css";

export default function UserSlider({
  users = [],            // array de usuarios
  title = "",            // título de la sección
  trackingContext = {},
}) {
  const tHome = useTranslations('common.shared.home');
  const navigate = useNavigate();
  const { state } = useStateHandler();
  const sliderRef = useRef(null);
  const impressionRef = useCarouselImpressionTracking(trackingContext);
  const [isScrolled, setIsScrolled] = useState(false);
  const handleSeeAll = () => {
    HomeCarouselAnalyticsService.trackHomeCarouselEvent(
      "carousel_see_all_click",
      {
        ...trackingContext,
        destination: "/search",
      },
      { userSession: state.user_session }
    );
    navigate("/search", { state: { category: "Users" } });
  };

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    const handleScroll = () => setIsScrolled(slider.scrollLeft > 0);
    slider.addEventListener("scroll", handleScroll);
    return () => slider.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div ref={impressionRef} className="user-slider__container">
      <div className="user-slider__header">
        <Heading className="home-title">{title}</Heading>
        <DiscoverHeaderControls viewportRef={sliderRef} />
      </div>
      <div className="full-bleed">
        <FHSlider
          ref={sliderRef}
          speed={1.4}
          className={`user-slider__slider ${isScrolled ? "scrolled" : ""}`}
          customPrevButton={<></>}
          customNextButton={<></>}
        >
          {users.length > 0
            ? users.map((user) => (
              <div
                className="user-slider__slider-item"
                key={user.id}
              >
                <UserSliderCard
                  user={user}
                  onVisit={() => {
                    if (!user.username) return;
                    HomeCarouselAnalyticsService.trackHomeCarouselEvent(
                      "carousel_item_click",
                      {
                        ...trackingContext,
                        itemId: user.id || user._id || user.username,
                        itemKind: "user",
                        destination: `/user/${user.username}`,
                      },
                      { userSession: state.user_session }
                    );
                    navigate(`/user/${user.username}`);
                  }}
                />
              </div>
            ))
            : (
              <div className="user-slider__slider-item p-4 text-center text-gray-500">
                {tHome('empty.no_users')}
              </div>
            )
          }

          {/* See all action, unified with HomeSlider styling */}
          <div className="user-slider__slider-item see-all-slide">
            <Text className="home-slider__see-all font-size-medium" onClick={handleSeeAll}>
              {tHome('see_all')}
            </Text>
          </div>
        </FHSlider>
      </div>
    </div>
  );
}
